import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';

const isClientSideRendering = windowManipulationService.isBrowserEnvironment();
// Naming: Služi za dohvat podataka definiranih u twigu "facilityUnit.html.twig" pa je naziv facilityWindowManipulationService,
// na isti način definirat ostale servise za manipulaciju nad window object-om.
export default class facilityWindowManipulationService {
    // Smatram da bi bilo bolje return spremiti i centralizirati u constructor-u i od tu ga koristiti, ali bilo je odrađeno
    // tako da se poziva iznova (dohvat iz data atributa) kad je potreban ovaj podatak, stoga sam ispratio to i svaki
    // put pozivam metodu kad tražim "facilityID".
    static getFacilityID() {
        try {
            if (isClientSideRendering && window?.PageConfig?.facilityID) {
                return window.PageConfig.facilityID;
            }
            reportError(new Error('Ne postoji window.PageConfig ili window.PageConfig.facilityID u "getFacilityID"'));

            return null;
        } catch (error) {
            reportError(new Error('Greška prilikom dohvata "facilityID" u servisu "getFacilityID":', error));
            return null;
        }
    }

    // Smatram da bi bilo bolje return spremiti i centralizirati u constructor-u i od tu ga koristiti, ali bilo je odrađeno
    // tako da se poziva iznova (dohvat iz data atributa) kad je potreban ovaj podatak, stoga sam ispratio to i svaki
    // put pozivam metodu kad tražim "unitID".
    static getUnitID() {
        try {
            if (isClientSideRendering && window?.PageConfig?.unitID) {
                return window.PageConfig.unitID;
            }
            // Za sada ne dojavljujemo error jer je inicijalno odrađeno da se unitID uopće ne sprema ako ne postoji (src\Adriatic\Bundle\ResponsiveFrontendBundle\Resources\views\Facility\facility.html.twig)
            // reportError(new Error('Ne postoji window.PageConfig ili window.PageConfig.unitID u "getUnitID"'));

            return null;
        } catch (error) {
            reportError(new Error('Greška prilikom dohvata "unitID" u servisu "getUnitID":', error));
            return null;
        }
    }

    // Smatram da bi bilo bolje return spremiti i centralizirati u constructor-u i od tu ga koristiti, ali bilo je odrađeno
    // tako da se poziva iznova (dohvat iz data atributa) kad je potreban ovaj podatak, stoga sam ispratio to i svaki
    // put pozivam metodu kad tražim "isOurSiteUser".
    static getIsOurSiteUser() {
        try {
            if (isClientSideRendering && window?.PageConfig?.isOurSiteUser) {
                return window.PageConfig.isOurSiteUser;
            }
            reportError(new Error('Ne postoji window.PageConfig ili window.PageConfig.isOurSiteUser u "getIsOurSiteUser"'));

            return null;
        } catch (error) {
            reportError(new Error('Greška prilikom dohvata "isOurSiteUser" u servisu "getIsOurSiteUser":', error));
            return null;
        }
    }
}
